var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Spanner = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 827.74 867.84", width: "1em", height: "1em" }, props),
    React.createElement("defs", null),
    React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
        React.createElement("g", { id: "icon" },
            React.createElement("path", { className: "cls-1", d: "M763.64 288H643.88a48 48 0 0 1 0-96h119.75A64 64 0 0 0 813 87.28 239.24 239.24 0 0 0 627.88 0h-1a240 240 0 0 0-168.7 409.71 240 240 0 0 0 354.69-16.81A64 64 0 0 0 763.64 288zm-.08 64.1A175.58 175.58 0 0 1 627.88 416c-97 0-176-78.95-176-176A175.58 175.58 0 0 1 627.14 64h.74a175.49 175.49 0 0 1 135.76 64H643.88a112 112 0 0 0 0 224h119.74zM285.25 441.37l-256 256a99.89 99.89 0 0 0 141.26 141.26l256-256a99.89 99.89 0 0 0-141.26-141.26zm96 96l-256 256a35.88 35.88 0 1 1-50.74-50.74l256-256a35.88 35.88 0 1 1 50.74 50.74z" }))))); };
export default Spanner;
//# sourceMappingURL=Spanner.js.map